<template >
  <splash></splash>
  <div class="container mt-4" dir="rtl">

    <sidebar></sidebar>
    <div style="    position: absolute;
    right: 28vw;
    width: 51vw; height: auto;" class="card-panel-main col-lg-9 mb-5">
      <div class="card card-body card-panel-box border-0" style="    margin: 1vw .9vw;">
        <center>
          <div class="d-flex justify-content-between align-items-center">
            <p style="font-size: 2vw">اطلاعات اثر    </p>


          </div>
          <hr>
          <br>
        </center>
        <p  v-show="!items.length" >
          اثر وجود ندارد
        </p>
        <div class="d-flex">
          <table  v-show="items.length"   class="table table-striped" style="width: 70vw;  " :style="dates.length>8 ? 'width: 120vw' : ''">
            <thead style="">
            <tr>
              <th>ردیف  </th>
              <th>کد  </th>
              <th>عنوان  </th>
              <th style="width: 10vw;">شاخص اندازه گیری    </th>
              <th>واحد سنجش شاخص    </th>


            </tr>
            </thead>

            <tr  v-for="(item,index) in items">
              <td scope="row" style="  font-size: 1vw">{{index+1}}</td>
              <td >{{item.code}}</td>
              <td >{{item.title}}</td>
              <td>{{item.measurement_chart}}</td>
              <td >{{item.unit }}</td>


            </tr>

          </table>
          <div style="overflow-x:scroll; width: 80vw;">
            <table  class="table table-striped" :style="dates.length>8 ? 'width: 150vw' : ''">
              <thead>
              <th v-for="itemDate in dates">
                <div v-if="itemDate.type === 'روزانه'"> {{itemDate.date}}</div>
                <div v-else-if="itemDate.type === 'هفتگی'"> {{setWeek(itemDate.date)}}</div>
                <div v-else-if="itemDate.type === 'ماهانه'"> {{ setMonth(itemDate.date.slice(5, 7)) + '-' + itemDate.date.slice(0,4) }}</div>
                <div v-else-if="itemDate.type === '6 ماهه'">    {{setSixMonth(itemDate.date)}}</div>
                <div v-else-if="itemDate.type === 'فصلی'">   {{setSeason(itemDate.date)}}</div>
                <div v-else-if="itemDate.type === 'سالانه'">سال   {{itemDate.date.slice(0,4)}}</div>
                <div v-else-if="itemDate.type === '3 ساله'">
                  3 ساله
                  <br>
                  {{itemDate.date.slice(0,4)}}-{{parseInt(itemDate.date.slice(0,4))+3}}
                </div>
              </th>
              </thead>
              <tr  v-for="(item,index) in items">
                <td v-for="(date,ind) in dates" style="width: 7vw;">
                  <input     type="number"  class="form-control" :id="'input_'+item.id+'_'+date.id"  >
                </td>
              </tr>
            </table>
          </div>
        </div>
        <br>
        <hr>
        <div class="d-flex align-items-center justify-content-center mt-5">
          <button @click.prevent="$router.back()"  class="btn btn-primary btn-add-org-post  " style="width: 7vw; margin-left: 1vw;">برگشت</button>
          <button v-show="items.length" @click="saveDataToServer" class="btn btn-primary  btn-approve">ذخیره</button>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Sidebar from "@/components/Sidebar/Sidebar";
import splash from "@/components/Splash/Splash";
import login from "@/views/auth/Login.vue";
import {useToast} from "vue-toastification";

export default {
  name: 'HomeView',
  components: {
    Sidebar,
    splash
  },
  data(){
    return{
      items: [],
      dates: [],
      keys: [],
      count: 0,
      period: '',

    }
  },


  methods:{
    setSixMonth(date) {
      const dateParts = date.split('-'); // جدا کردن سال، ماه و روز از تاریخ ورودی
      const year = dateParts[0];
      const month = dateParts[1];
      const day = dateParts[2];

      // تشخیص دوره 6 ماهه بر اساس ماه
      let period = '';
      if (month >= 1 && month <= 6) {
        period = 'اول';
      } else {
        period = 'دوم';
      }

      // تشکیل متن نهایی
      const weekText = `6 ماه ${period} ${year}`;

      return weekText;
    },

    setSeason(date) {
      const dateParts = date.split('-'); // جدا کردن سال، ماه و روز از تاریخ ورودی
      const year = dateParts[0];
      const month = dateParts[1];
      const day = dateParts[2];

      // تشخیص فصل بر اساس ماه و روز
      let season = '';
      if ((month >= 1 && month <= 2) || (month === 12 && day >= 21)) {
        season = 'بهار';
      } else if (month >= 3 && month <= 5) {
        season = 'تابستان';
      } else if (month >= 6 && month <= 8) {
        season = 'پاییز';
      } else if (month >= 9 && month <= 11) {
        season = 'زمستان';
      }

      // تشکیل متن نهایی
      const weekText = ` ${season} ${year}`;

      return weekText;
    },

    setWeek(date) {
      const dateParts = date.split('-'); // جدا کردن سال، ماه و روز از تاریخ ورودی
      const year = dateParts[0];
      const month = dateParts[1];
      const day = dateParts[2];

      // تشخیص هفته بر اساس روز
      const week = Math.ceil(day / 7);

      // تشکیل متن نهایی
      const weekText = `هفته ${this.setNumber(week)}   ${this.setMonth(month)} ${year}`;

      return weekText;
    },

    setMonth(number){
      if (number==='01') return 'فرودین'
      if (number==='02') return 'اردیبهشت'
      if (number==='03') return 'خرداد'
      if (number==='04') return 'تیر'
      if (number==='05') return 'مرداد'
      if (number==='06') return 'شهریور'
      if (number==='07') return 'مهر'
      if (number==='08') return 'آبان'
      if (number==='09') return 'آذر'
      if (number==='10') return 'دی'
      if (number==='11') return 'بهمن'
      if (number==='12') return 'اسفند'
    },
    setNumber(number){
      if (number===1) return 'اول'
      if (number===2) return 'دوم'
      if (number===3) return 'سوم'
      if (number===4) return 'چهارم'
      if (number===5) return 'پنجم'
      if (number===6) return 'ششم'
      if (number===7) return 'هفتم'
      if (number===8) return 'هشتم'
      if (number===9) return 'نهم'
      if (number===10) return 'دهم'
      else return number
    },
    allItems(){
      var myHeaders = new Headers();

      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();

      formdata.append('code', this.code)
      formdata.append('title', this.title)
      formdata.append('process_id', this.inserterId)
      formdata.append('monitoring_process_id', this.unit_id)
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/definition_effect/all`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.items){
              this.items.length=0
              response.items.forEach((item)=>{
                this.items.push(item)
              })
              this.count = response.count
              this.period = response.period
              this.allKeys()


            }



          })
          .catch();

    },
    allKeys(){
      var myHeaders = new Headers();

      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/budget_information/all_effect`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.items){

              response.items.forEach((item)=>{
                this.dates.push(item)


              })








            }
            if (response.keys){
              response.keys.forEach((ele)=>{
                this.keys.push(ele)
                setTimeout(()=>{
                  document.querySelector(`input[id=input_${ele.count}_${ele.effect_information_id}]`).value = ele.value
                },1000)
              })
            }



          })
          .catch();




    },
    saveDataToServer() {
      const toast = useToast();
      // ایجاد یک آرایه برای ذخیره اطلاعات ورودی‌ها
      const inputDataArray = [];

      // برای هر ردیف از ورودی‌ها، یک شی JSON ایجاد کرده و آن را به آرایه اضافه کنید
      for (const item of this.items) {
        this.dates.forEach((ele,index)=>{
          const inputId = ele.id;
          const inputValue = document.getElementById(`input_${item.id}_${ele.id}`).value;

          const inputInfo = {
            effect_information_id: inputId,
            value: inputValue,
            count: item.id,
          };

          inputDataArray.push(inputInfo);
        })
      }
      var myHeaders = new Headers();

      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();

      formdata.append('data', JSON.stringify(inputDataArray))
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/budget_information/store`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.message){
              toast.success(response.message);

            }



          })
          .catch();

    }
  },
  mounted() {
    this.allItems()


  },

}
</script>